<section class="after-selfie">
  <img src="assets/images/verify_selfie.svg" width="160" alt="selfie">

  <div class="after-selfie__title">Confirma foto</div>

  <p>Verifique se a foto <strong>mostra claramente o seu rosto.</strong></p>

  <img *ngIf="fotoUrl" [src]="fotoUrl" width="300" alt="selfie">

</section>
